import bayaraNigeriaLogo from "@/assets/brands/bayara_nigeria_logo_1x1.png";
import bountyLogo from "@/assets/brands/bounty_logo_1x1.png";
import braggLogo from "@/assets/brands/bragg_logo_1x1.png";
import chhedasLogo from "@/assets/brands/chhedas_logo_1x1.png";
import chupaChupsLogo from "@/assets/brands/chupa_chups_logo_1x1.png";
import cornitosLogo from "@/assets/brands/cornitos_logo_1x1.png";
import daawatLogo from "@/assets/brands/daawat_logo_1x1.png";
import dorallCollectionLogo from "@/assets/brands/dorall_collection_logo_1x1.png";
import evianLogo from "@/assets/brands/evian_logo_1x1.png";
import fijiWaterLogo from "@/assets/brands/fiji_water_logo_1x1.png";
import foodleaLogo from "@/assets/brands/foodlea_logo_1x1.png";
import goldenCountryLogo from "@/assets/brands/golden_country_logo_1x1.png";
import indiaGateLogo from "@/assets/brands/india_gate_logo_1x1.png";
import kettleStudioLogo from "@/assets/brands/kettle_studio_logo_1x1.png";
import lotusBiscoffLogo from "@/assets/brands/lotus_biscoff_logo_1x1.png";
import maggiLogo from "@/assets/brands/maggi_logo_1x1.png";
import marsLogo from "@/assets/brands/mars_logo_1x1.png";
import mybizcuitLogo from "@/assets/brands/mybizcuit_logo_1x1.png";
import myspreadMybizcuitLogo from "@/assets/brands/myspread_mybizcuit_logo_1x1.png";
import natureValleyLogo from "@/assets/brands/nature_valley_logo_1x1.png";
import oreoLogo from "@/assets/brands/oreo_logo_1x1.png";
import perrierLogo from "@/assets/brands/perrier_logo_1x1.png";
import primeLogo from "@/assets/brands/prime_logo_1x1.png";
import pureHeavenLogo from "@/assets/brands/pure_heaven_logo_1x1.png";
import royalArmLogo from "@/assets/brands/royal_arm_logo_1x1.png";
import royaltyLogo from "@/assets/brands/royalty_logo_1x1.png";
import sanPellegrinoLogo from "@/assets/brands/san_pellegrino_logo_1x1.png";
import sankalpLogo from "@/assets/brands/sankalp_logo_1x1.png";
import snickersLogo from "@/assets/brands/snickers_logo_1x1.png";
import superChefLogo from "@/assets/brands/super_chef_logo_1x1.png";
import tridentLogo from "@/assets/brands/trident_logo_1x1.png";

export interface BrandLogo {
  name: string;
  src: string;
}

export const BRAND_LOGOS: BrandLogo[] = [
  { name: "Bayara Nigeria", src: bayaraNigeriaLogo },
  { name: "Bounty", src: bountyLogo },
  { name: "Bragg", src: braggLogo },
  { name: "Chheda's", src: chhedasLogo },
  { name: "Chupa Chups", src: chupaChupsLogo },
  { name: "Cornitos", src: cornitosLogo },
  { name: "Daawat", src: daawatLogo },
  { name: "Dorall Collection", src: dorallCollectionLogo },
  { name: "Evian", src: evianLogo },
  { name: "Fiji Water", src: fijiWaterLogo },
  { name: "Foodlea", src: foodleaLogo },
  { name: "Golden Country", src: goldenCountryLogo },
  { name: "India Gate", src: indiaGateLogo },
  { name: "Kettle Studio", src: kettleStudioLogo },
  { name: "Lotus Biscoff", src: lotusBiscoffLogo },
  { name: "Maggi", src: maggiLogo },
  { name: "Mars", src: marsLogo },
  { name: "MyBizcuit", src: mybizcuitLogo },
  { name: "MySpread", src: myspreadMybizcuitLogo },
  { name: "Nature Valley", src: natureValleyLogo },
  { name: "Oreo", src: oreoLogo },
  { name: "Perrier", src: perrierLogo },
  { name: "Prime", src: primeLogo },
  { name: "Pure Heaven", src: pureHeavenLogo },
  { name: "Royal Arm", src: royalArmLogo },
  { name: "Royalty", src: royaltyLogo },
  { name: "San Pellegrino", src: sanPellegrinoLogo },
  { name: "Sankalp", src: sankalpLogo },
  { name: "Snickers", src: snickersLogo },
  { name: "Super Chef", src: superChefLogo },
  { name: "Trident", src: tridentLogo },
];
